import { AccessLevel, RoleName, TokenSource } from "types/JWT";
import { Permissions, jwtPayload } from "atoms/auth";
import { useRecoilValue } from "recoil";
import { userSelectedRoleAtom } from "atoms/userSelectedRole";

export interface UserInfo {
  id: string;
  userEmail: string;
  roleName: RoleName;
  permissions?: Permissions;
  accessLevel: AccessLevel;
  name: string;
  userId: string;
  masqueradeUserId: string | undefined;
  masqueradeUserEmail: string | undefined;
  offices: string[] | undefined;
  propertId?: string;
  tokenSource?: TokenSource;
  agentId?: string;
}

const useUserInfo = (): UserInfo => {
  const payload = useRecoilValue(jwtPayload);
  const selectedRole = useRecoilValue(userSelectedRoleAtom);

  if (!payload)
    return {
      roleName: "Seller",
      accessLevel: "Property",
      userEmail: "",
      permissions: selectedRole.permissions,
      id: "",
      name: "",
      userId: "",
      masqueradeUserEmail: undefined,
      masqueradeUserId: undefined,
      offices: []
    };

  return {
    userEmail: payload.email,
    roleName: (selectedRole?.name ?? "Seller") as RoleName,
    id: payload.id,
    userId: payload.userId,
    accessLevel: selectedRole.accessLevel as AccessLevel,
    permissions: selectedRole.permissions,
    name: `${payload.given_name ?? ""}${
      payload.family_name ? ` ${payload.family_name}` : ""
    }`,
    masqueradeUserId: payload.masqueradeUserId,
    masqueradeUserEmail: payload.masqueradeUserEmail,
    offices: payload?.offices?.split(",") ?? [],
    propertId: payload?.propertyId,
    tokenSource: payload.tokenSource,
    agentId: payload.agentId
  };
};

export default useUserInfo;
